import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from 'shared/state/store';
import React from 'react';
import AppResolver from './AppResolver';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
console.log("[ADP Student App]","loading ADP App")
root.render(
   <Provider store={store}>
    <AppResolver />
    </Provider>
);
